import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useDokumentyReklamaceContextInstance } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';

interface DocumentComplainSubmitButtonProps {
	onClick?: () => void;
	code: PageCode;
	formId: string;
}

export const DocumentComplainSubmitButton = ({
	onClick,
	formId,
	code,
}: DocumentComplainSubmitButtonProps) => {
	const { controls } = useDokumentyReklamaceContextInstance();
	const { t } = useLocale(code);
	const isProcessing = controls.processLoading;

	return (
		<Button
			isLoading={controls.processLoading}
			isDisabled={isProcessing}
			onClick={onClick}
			nativeType="submit"
			form={formId}
			color="primary"
			size="m"
			type="solid"
			isExpandedMobile
			aria-label={t('akce.odeslat-reklamaci')}>
			{t('akce.odeslat-reklamaci')}
		</Button>
	);
};
